// Returns a function that runs async tasks strictly one after another, in the order added.
// A failing task rejects its own promise and does not stop the ones behind it.
export const createSerialQueue = () => {
  let tail: Promise<unknown> = Promise.resolve();

  return <T>(task: () => Promise<T>): Promise<T> => {
    const run = tail.then(task, task);
    tail = run.catch(() => undefined);
    return run;
  };
};
